import { Box } from "@mui/material";
import CustomDialog from "components/CustomDialog";
import SubCategoryForm from "pages/product_category/SubCategoryForm";
import React from "react";

const SubCategoryDialog = ({
  open,
  handleClose,
  category,
  fullGrid,
  update = false,
  subCategory,
}) => {
  return (
    <CustomDialog
      forceFullScreen={true}
      open={open}
      handleClose={handleClose}
      heading={update ? "Update sub category" : "Create sub category"}
    >
      <Box padding={2}>
        <SubCategoryForm
          category={category}
          fullGrid={fullGrid}
          subCategory={subCategory}
        />
      </Box>
    </CustomDialog>
  );
};

export default SubCategoryDialog;
